import { useTranslation } from "react-i18next";
import { useBrand } from "./useBrand";

export function useBrandName() {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Brand:BrandName",
  });
  const { brandTwoLetterCode } = useBrand();
  return t(brandTwoLetterCode);
}
